import React from 'react'
import "./SectionHeading.css"

export default function SectionHeading(props) {
    return (
        <div className="sectionHeadPart">

            <h2 className="heading">{props.heading}</h2>
            <h6 className="description">{props.description}</h6>

        </div>
    )
}
